import { render } from "./DogCard.vue?vue&type=template&id=ac923bb2"
import script from "./DogCard.vue?vue&type=script&lang=js"
export * from "./DogCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__